import { adminHttpClient } from '../commons/adminHttpClient'

export type EndAnnualInsuranceRequest = {
  planPeriodId: string
  endDate: string
  insuranceRequest?: NewInsuranceRequest
}

type NewInsuranceRequest = {
  providerName: string
  policyName: string
  startDate: string
}

const endAnnualInsurance = (request: EndAnnualInsuranceRequest): Promise<void> => {
  return adminHttpClient.post(`/Benefit/EndMonthInsurance`, request)
}

export default endAnnualInsurance
